import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Navbar } from 'react-bootstrap';

import DesktopMenu from 'components/navigation/desktop-menu/desktop-menu.component';
import MobileMenu from 'components/navigation/mobile-menu/mobile-menu.component';

import './style.css';

const Navigation = ({ token }) => {
    const [isScrolled, setIsScrolled] = useState(false);

    const classes = classNames('navigation', { scrolled: isScrolled });

    const handleScroll = () => {
        //  if the window scrollY passes below the bottom of the navs
        if (window.scrollY >= 1) {
            setIsScrolled(true);
            return;
        }
        //  if the window scrollY passes above the bottom of the nav
        if (window.scrollY - 74 <= 0 && isScrolled) {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        if (window) {
            window.addEventListener('scroll', handleScroll);
        }
        return () => window.removeEventListener('scroll', handleScroll);
    });

    return (
        <Navbar expand="lg" sticky="top" className={classes}>
            <DesktopMenu token={token} />
            <MobileMenu token={token} />
        </Navbar>
    );
};

export default Navigation;
